import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const WorkflowActionTaskCreateIcon = ({ className = "w-8 h-8" }) => (
  <SvgSpriteIcon iconName="workflow-actions-task-create" className={className} />
)

WorkflowActionTaskCreateIcon.propTypes = {
  className: types.string,
}

export default WorkflowActionTaskCreateIcon
